import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/styles";
import React from "react";
import NumberFormat from "react-number-format";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import "../styles/style.css";
import theme from "../styles/theme";

import CircularLoading from "../components/CircularLoading";
import { getCatalogImage, GetProductCatalogByID } from "../services/Product";
import {
    GetRole, GetToken, GuestLogin, Me, RefreshSession, SetSession, SetToken,
    GetUser, SetUser, SetReferral
} from "../services/Session";

const qs = require('query-string')
const BackIcon = "/assets/svg/back-white.svg";
const ShareIcon = "/assets/svg/share-white.svg";

class ProductDetail extends React.Component {
  constructor(props) {
    super(props);
    let q = qs.parse(this.props.location.search)
    this.state = {
      data: {},
      token: q?.token,
      referral_code: q?.ref,
      product_type: "",
      product_id: "",
      product_code: "",
      product_images: [],
      product_name: "",
      product_description: "",
      unit_price: {
        min: 0,
      },
      discount_rate: 0,
      loading: false
    };
  }

  componentDidMount = () => {
    if (!this.state || !this.state.product_id) {
      this.handleGetProduct();
      this.handleGetImagesProduct();
    }
  }

  handleGetProduct = async () => {
    this.setState({ loading: true });
    let code = this.props.match.params.id
    let token = this.state.token
    let q = token ? { "code": code, is_active: true, token: token } : { "code": code, is_active: true }
    if (this.state.referral_code) {
      SetReferral(this.state.referral_code)
    }
    GetProductCatalogByID(code, q)
      .then(res => {
        this.setState({
          loading: false,
        });
        if (res.data.id) {
          this.setState({
            data: res.data,
            product_type: res.data.type,
            product_id: res.data.id,
            product_code: res.data.code,
            product_name: res.data.name,
            product_description: res.data.description,
            unit_price: res.data.unit_price,
            discount_rate: res.data.discount_rate,
            image_url: res.data.image.url,
          });
        }
        if (res.data.token) {
          Me(SetToken(res.data.token).access_token).then((u) => {
            SetUser(u.data);
            setTimeout(this.props.history.push("/produk/" + res.data.code), 3000);
          });
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        if (err.response) {
          if (err.response.status === 401) {
            if (GetToken().refresh_token !== null) {
              RefreshSession(GetToken().refresh_token);
            } else {
              GuestLogin().then(res => {
                SetSession(res.data.token);
                setTimeout(this.handleGetProduct(), 5000);
              });
            }
          } else if (
            err.response.data.error &&
            err.response.data.error &&
            err.response.data.error.message
          ) {
            alert(err.response.data.error.message);
          } else {
            alert("gagal terhubung ke server");
          }
        } else {
          alert("gagal terhubung ke server");
        }
      });
  };

  handleGetImagesProduct = () => {
    this.setState({ loading_images: true });
    getCatalogImage({
      'product.catalog.code': this.props.match.params.id, 
      'sort_number.$gt': 0, 
      'sorts': 'sort_number',
    })
      .then(res => {
        if (res.data.count > 0) {        
          this.setState({
            loading_images: false,
            product_images: res.data.results,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        if (err.response) {
          if (err.response.status === 401) {
            if (GetToken().refresh_token !== null) {
              RefreshSession(GetToken().refresh_token);
            } else {
              GuestLogin().then(res => {
                SetSession(res.data.token);
                setTimeout(this.handleGetImagesProduct(), 5000);
              });
            }
          } else if (
            err.response.data.error &&
            err.response.data.error &&
            err.response.data.error.message
          ) {
            alert(err.response.data.error.message);
          } else {
            alert("gagal terhubung ke server");
          }
        } else {
          alert("gagal terhubung ke server");
        }
      });
  };

  handleSubmit(product_id) {
    this.props.history.push({
      pathname: this.getNextPath(),
      state: {
        product_type: this.state.product_type,
        product_id: this.state.product_id,
        product_code: this.state.product_code,
        product_name: this.state.product_name,
        product_description: this.state.product_description,
        unit_price: this.state.unit_price.min,
        image_url: this.state.image_url
      }
    });
  }

  getNextPath() {
    if (this.state.product_type === 'ticket') {
      return '/pesan-tiket'
    } else if (this.state.product_type === 'certificate') {
      return '/pesan-sertifikat'
    } else if (this.state.product_type === 'pre_order_member') {
      return '/pesan-pre-order-member'
    } else if (this.state.product_type === 'pre_order_internal') {
      return '/pesan-pre-order-internal'
    } else {
      return '/pesan-produk'
    }
  }

  renderProduct() {
    let { data, loading_images, unit_price, discount_rate, product_images } = this.state

    let net_price = discount_rate ? unit_price.min * (1 - (discount_rate / 100)) : unit_price.min

    return (
      <div
        style={{ display: "inline-flex", width: '100%', maxWidth: 540 }}
        key={data.id}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "auto",
            textAlign: "left"
          }}
        >
          {loading_images ?
            <div style={{ margin: '0 auto', display: 'table', padding: '30px' }} ><CircularLoading /> </div> :
            <Carousel showThumbs={false} emulateTouch infiniteLoop >
              {product_images.map((image, idx) => <div key={idx}><img alt="produk" src={image.image.url} style={{ width: "100%" }} /></div>)}
            </Carousel>
          }
          <div
            style={{
              paddingLeft: 10,
              paddingRight: 10,
              paddingBottom: 60
            }}
          >
            <b>
              <h1 style={{ paddingTop: 10, textAlign: "center", fontSize: 18 }}>{data.name}</h1>
            </b>
            <section
              style={{
                textAlign: "right",
                paddingTop: 10,
                paddingBottom: 10,
                color: "#00BFE6",
                fontSize: 24
              }}
            >
              {discount_rate && (
                <div style={{ fontSize: 16, color: '#666' }}>
                  <span>Diskon <NumberFormat
                      decimalScale={2}
                      value={discount_rate}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      suffix={'% '}
                    /></span>
                  <span style={{ textDecoration: 'line-through' }}>
                    <NumberFormat
                      fixedDecimalScale decimalScale={0}
                      value={unit_price.min}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      prefix={'Rp '}
                    />
                  </span>
                </div>
              )}
              <b>
                <NumberFormat
                  fixedDecimalScale decimalScale={0}
                  value={net_price}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"Rp "}
                />
              </b>
            </section>
            <section
              style={{ padding: 0 }}
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    let submitOrder = () => {
      if (GetRole().id <= 1) {
        alert("Silakan masuk terlebih dahulu");
        this.props.history.push("/login?redirect=" + encodeURIComponent(window.location.href));
      } else if (this.state.product_id) {
        this.handleSubmit();
      }
    };

    let csUrl = this.state.product_type === 'ticket' ? "https://tanyadaurah.hsi.id" : "/callback/contact_rotators/kontak?text=" + encodeURI("Assalamu'alaykum\nAna mau tanya ini " + window.location.href);
    let buttonLabel = this.state.product_type === 'ticket' ? "Daftar Sekarang" : "Pesan Sekarang";
    let backPath = this.state.product_type === 'pre_order_internal' ? "/pre-order-internal" : "/";
    let user = GetUser()
    let referralURL = (user?.nip && user?.is_affiliate) ? '?ref='+user.nip : ''

    return (
      <ThemeProvider theme={theme}>
        <div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
        <div
          className="header"
          style={{ background: "rgba(0, 0, 0, 0.6)" }}
        >
          <Link
            to={backPath}
            style={{
              position: "absolute",
              height: 60,
              width: 60,
              top: 0,
              left: 0,
            }}
          >
            <img alt="icon" src={BackIcon} />
          </Link>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://api.whatsapp.com/send?text=" + encodeURI(window.location.href + referralURL )}
            style={{
              textDecoration: "none",
              position: "absolute",
              height: 60,
              width: 60,
              top: 0,
              right: 0,
            }}
          >
            <img alt="icon" src={ShareIcon} />
          </a>
        </div>
        <div className="wrapper" style={{ paddingTop: 0 }}>
          {this.state.loading ? (
            <div
              className="center"
              style={{ marginTop: 80, width: 40, height: 40 }}
            >
              <CircularLoading />
            </div>
          ) : (
            this.renderProduct()
          )}
        </div>
        <div className="footer">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={csUrl}
            style={{ textDecoration: "none", paddingRight: 10 }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{ textTransform: "none", height: 40, width: 100, top: 10 }}
              startIcon={<WhatsAppIcon />}
            >
              Chat
            </Button>
          </a>
          <Button
            onClick={submitOrder}
            variant="contained"
            color="primary"
            style={{ textTransform: "none", height: 40, width: 200, top: 10 }}
          >
            {buttonLabel}
          </Button>
        </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default ProductDetail;
